module.exports = __webpack_public_path__ + "img/new-guide-03-4.25936884.png";